import React from 'react';
import { defineMessages } from 'react-intl';
import Button from '@alltrails/shared/denali/components/Button';
import useFormatMessage from 'hooks/useFormatMessage';
import useUser from 'hooks/useUser';
import useFeatures from 'hooks/useFeatures';
import CustomProvider from 'components/CustomProvider';
import { logProfileProUpgradeButtonClicked } from '@alltrails/analytics/amplitudeFunctions';
import * as styles from './styles.module.scss';

const messages = defineMessages({
  tryProFree: {
    defaultMessage: 'Try Pro for Free'
  },
  doMoreWithPro: {
    defaultMessage: 'Do More with AllTrails Pro!'
  }
});

function DoMoreWithProContent() {
  const {
    formattedDefaultMessages: { tryProFree, doMoreWithPro }
  } = useFormatMessage(messages);

  const user = useUser();
  const features = useFeatures();

  return (
    <div className={styles.doMoreWithPro}>
      <Button
        text={user.isPromoEligible && features.includes('seven_day_trial') ? tryProFree : doMoreWithPro}
        linkInfo={{ href: '/pro?ref=my-profile-edit' }}
        onClick={() => {
          logProfileProUpgradeButtonClicked();
        }}
        testId="do-more-with-pro"
        variant="primary"
      />
    </div>
  );
}

export default function DoMoreWithPro() {
  return (
    <CustomProvider>
      <DoMoreWithProContent />
    </CustomProvider>
  );
}
